import { render, staticRenderFns } from "./advertisementInfo.vue?vue&type=template&id=7535ef35&scoped=true"
import script from "./advertisementInfo.vue?vue&type=script&lang=js"
export * from "./advertisementInfo.vue?vue&type=script&lang=js"
import style0 from "./advertisementInfo.vue?vue&type=style&index=0&id=7535ef35&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7535ef35",
  null
  
)

export default component.exports